module.exports = __webpack_public_path__ + "img/logo.6cfded1c.jpg";